const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://oludamilare.netlify.app/',
  title: 'Dami.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Damilare Jolayemi',
  role: 'Software Engineer and Technical Writer',
  descriptionOne:
    'I operate on a technical pedestal with over half a decade of experience spanning the Tech and Financial ecosystems. I\'m proficient in building, deploying and maintaining scalable web services and infrastructures.',
    descriptionTwo: 'I\'m also recognised for my ability to communicate complex technical concepts in simple and clear terms to technical and non-technical personnel of varying levels of expertise. My skills include but are not limited to Software Engineering, Systems Architecture and Technical Writing.',
    descriptionThree: 'During my spare time, you\'d typically find me hopping across different cities in an attempt to satisfy my curiosity and adventures.',
  resume: 'https://docs.google.com/document/d/11s7Ex7QDH3h3de-L7Z8Wn7EsGQMARU1_ctGdrYN2yYI/edit?tab=t.0',
  social: {
    linkedin: 'https://www.linkedin.com/in/damilare-jolayemi/',
    github: 'https://github.com/olu-damilare',
  },
}

const articles = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'Integrating Flask and Flutter apps',
    description:
    'Discover how to integrate your frontend Flutter application with a Flask backend service!',
    stack: ['Dart, Flutter'],
    sourceCode: 'https://blog.logrocket.com/integrating-flask-flutter-apps/',
  },
  {
    name: 'Creating an adaptive app with Flutter',
    description:
    'Adaptive apps, not to be confused with responsive apps, deliver different views for different devices and screen sizes. Build one here!',
    stack: ['Dart, Flutter'],
    sourceCode: 'https://blog.logrocket.com/creating-adaptive-app-flutter/',
  },
  {
    name: 'Build a full-stack app with Tetra',
    description:
    'Learn how to build a simple full-stack blog application while getting familiar with the Tetra framework and its components.',
    stack: ['Python, Flask'],
    sourceCode: 'https://blog.logrocket.com/build-full-stack-app-tetra/',
  },
  {
    name: 'How to implement infinite scroll pagination in Flutter',
    description:
    'Learn three different ways to implement Instagram-like scroll experiences in your Flutter apps in this detailed tutorial.',
    stack: ['Dart, Flutter'],
    sourceCode: 'https://blog.logrocket.com/implement-infinite-scroll-pagination-flutter/',
  },
  {
    name: 'Build a hotel-booking app with Flutter - Part 2',
    description:
    'Here, I demonstrated the full implementation of building the hotel-booking application through Amadeus API services',
    stack: ['Dart, Flutter, Amadeus'],
    sourceCode: 'https://developers.amadeus.com/blog/flutter-hotel-booking-part-2',
  },
  {
    name: 'Build a hotel-booking app with Flutter - Part 1',
    description:
    'Here, you will learn how to set up your Amadeus developer account, get your API key, and generate an access token. You’ll also learn how to set up your Flutter application and the required tools, then connect your application to the Amadeus APIs.',
    stack: ['Dart, Flutter, Amadeus'],
    sourceCode: 'https://developers.amadeus.com/blog/flutter-hotel-booking',
  },

  {
    name: 'How to build a Telehealth app with Flutter and 100ms',
    description:
    'This tutorial provides a detailed guide on how you can integrate the 100ms audio/visual API to build a telehealth app with Flutter',
    stack: ['Dart, Flutter, 100ms'],
    sourceCode: 'https://www.100ms.live/blog/telehealth-app-with-flutter-100ms/',
  },

  {
    name: 'A guide to advanced Flutter animations.',
    description:
    'In this tutorial, learn about advanced animations available in Flutter and how you can implement a variety of different custom animation styles.',
    stack: ['Dart, Flutter'],
    sourceCode: 'https://blog.logrocket.com/guide-advanced-flutter-animations/',
  },
  

  {
    name: 'How To Build Web Crawler With Java.',
    description:
    'This tutorial will introduce you to building a basic web crawler and will help you understand the fundamental algorithm that makes web crawlers work. It will also cover some use cases and the challenges involved with building one.',
    stack: ['Java'],
    sourceCode: 'https://www.section.io/engineering-education/how-to-build-a-web-crawler-with-java/',
  },

  {
    name: 'How to build and deploy a Telegram bot with Flask',
    description:
    'This tutorial demonstrates how to build a Telegram bot and then integrate it with Flask to build a customized dictionary app quickly and deploy...',
    stack: ['Python', 'Flask', 'Telegram'],
    sourceCode: 'https://blog.logrocket.com/build-deploy-telegram-bot-with-flask/',
  },
 
  {
    name: 'Build and deploy a Flask app using Docker',
    description:
    'Learn how to deploy a Flask app using Docker, as well as how to host on Heroku, in this step-by-step Python tutorial.',
    stack: ['Python', 'Flask', 'Docker', 'Heroku'],
    sourceCode: 'https://blog.logrocket.com/build-deploy-flask-app-using-docker/',
  },
  
  {
    name: 'Dart and Flutter data structures: A comprehensive guide',
    description:
    'Learn how to choose from the many Dart and Flutter data structures available to use, and when to use each one, in this detailed...',
    stack: ['Dart'],
    sourceCode: 'https://blog.logrocket.com/dart-flutter-data-structures-comprehensive-guide/',
  },

  {
    name: 'Build a Python web scraper with Beautiful Soup',
    description:
    'Web scraping can be one of the most important things you can learn in Python. Learn about web scraping with Beautiful Soup in this...',
    stack: ['Python'],
    sourceCode: 'https://blog.logrocket.com/build-python-web-scraper-beautiful-soup/',
  },

  {
    name: 'Flutter Redux: Complete tutorial with examples',
    description:
    'Learn about data flow, state management structure, and using Redux in your Flutter apps in this detailed tutorial.',
    stack: ['Flutter', 'Redux'],
    sourceCode: 'https://blog.logrocket.com/flutter-redux-complete-tutorial-with-examples/',
  },
  {
    name: 'Containerizing Flutter web apps with Docker',
    description:
      'Learn how to containerize your Flutter web apps, allowing them to run consistently on any operating system or infrastructure.',
    stack: ['Flutter', 'Docker'],
    sourceCode: 'https://blog.logrocket.com/containerizing-flutter-web-apps-with-docker/',
  },
  {
    name: 'Getting Started with Spring Boot Security Antmatchers',
    description:
      'As a backend developer, the API you build will typically be for consumption by other applications or services. The sensitivity of the data carried by an application varies from application to application.',
    stack: ['Java', 'Springboot'],
    sourceCode: 'https://www.section.io/engineering-education/springboot-antmatchers/',
  },
  {
    name: 'Choosing the right progress indicators for async Flutter apps',
    description:
      'Progress indicators are important for communicating with your users. Read up on choosing the right ones for async Flutter apps in this post.',
    stack: ['Flutter'],
    sourceCode: 'https://blog.logrocket.com/choosing-right-progress-indicators-async-flutter-apps/',
  },
  {
    name: 'Getting started with REGEX with Java',
    description:
      'The need to validate string inputs is a ubiquitous necessity that projects require every developer to use at some point in their programming activities. A regular expression, popularly referred to as regex, is a...',
    stack: ['Java', 'Regex'],
    sourceCode: 'https://www.section.io/engineering-education/regex-implementation-with-java/',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'Java', 
  'Python', 
  'JavaScript', 
  'Dart', 
  'HTML/CSS', 
  'Rust',
  'Springboot', 
  'Django', 
  'React', 
  'Flutter', 
  'Bootstrap',
  'GIT', 
  'Docker',
  'AWS', 
  'Heroku', 
  'Blockchain', 
  'Technical Writing'

]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'djolayemi@mail.com',
}

export { header, about, articles, skills, contact }
